import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ConfirmationModalData, ConfirmationModalResult, ConfirmationModalComponent } from "src/app/component/confirmation-modal/confirmation-modal.component";


@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalService {

  constructor(private dialog: MatDialog) { }

  open(data: ConfirmationModalData = {}): Observable<ConfirmationModalResult | undefined> {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '500px',
      maxWidth: '95vw',
      disableClose: true,
      autoFocus: true,
      data: {
        title: 'Confirmación',
        placeholder: 'Descripción',
        required: false,
        maxLength: 500,
        yesText: 'Sí',
        noText: 'No',
        ...data
      }
    });

    return dialogRef.afterClosed();
  }

  // Métodos helper para casos comunes
  openSimple(
    title: string,
    message?: string,
    required: boolean = false
  ): Observable<ConfirmationModalResult | undefined> {
    return this.open({
      title,
      message,
      required
    });
  }

  openForAction(
    title: string,
    message: string,
    actionText: string = 'Confirmar'
  ): Observable<ConfirmationModalResult | undefined> {
    return this.open({
      title,
      message,
      yesText: actionText,
      required: true
    });
  }
}

export { ConfirmationModalComponent };
